import React from "react";
import profile from "../../assests/icons/profile.png";
import { useSelector } from "react-redux";

const Profile = () => {
  const { userInfo } = useSelector((state) => state.login);

  return (
    <div className="px-3">
      <h2>Profile</h2>
      <div>
        <div className="text-center">
          <img
            src={profile}
            alt="Admin Display"
            className="img-fluid"
            style={{ width: "200px" }}
          />
        </div>
        <div className="container mt-5">
          <div className="row">
            <div className="col-md-6">
              <p>
                <span className="fw-semibold">Auth ID</span>
                <br />
                <span>{userInfo?.authId}</span>
              </p>
              <p>
                <span className="fw-semibold">Email</span>
                <br />
                <span>Admin</span>
              </p>
              <p>
                <span className="fw-semibold">IP Address</span>
                <br />
                <span>2401:4900:884 7</span>
              </p>
            </div>
            <div className="col-md-6">
              <p>
                <span className="fw-semibold">Last Login</span>
                <br />
                <span>2024-12-31 11:46:46</span>
              </p>
              <p>
                <span className="fw-semibold">Last Logout</span>
                <br />
                <span>2024-12-30 03:38:30</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
